import axios from 'axios';

export const saveFee = (data) => {
    return axios.post('/api/admin/fees', data);
};

export const getFees = () => {
    return axios.get('/api/admin/fees');
};

export const archiveFee = (feeId, data) => {
    return axios.patch(`/api/admin/fees/${feeId}/archive`, data);
};
